(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbUserLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbUserLib"] = factory();
	else
		root["sbUserLib"] = factory();
})(window, function() {
return 